'use client'

import {
  Anchor,
  Button,
  H1,
  H2,
  H3,
  Text,
  Paragraph,
  Separator,
  Sheet,
  XStack,
  YStack,
  Theme,
} from 'tamagui'
import React, { useState } from 'react'
import Image from 'next/image'
import { ExtraLogo } from './common/ExtraLogo'

export function AppLayout({ children, ...props }) {
  return (
    <YStack flex={1} alignItems="center" {...props}>
      <XStack justifyContent='center' backgroundColor={'transparent'} p={24} pb={0}>
        <ExtraLogo />
      </XStack>
      <YStack maxWidth="800px" flex={1} p={24} justifyContent="center" alignItems="center" space pb={48}>
        {children}
      </YStack>
    </YStack>
  )
}
